import React from "react";
import {
  IoAccessibility,
  IoAccessibilityOutline,
  IoAccessibilitySharp,
  IoAdd,
  IoAddCircle,
  IoAddCircleOutline,
  IoAddCircleSharp,
  IoAddOutline,
  IoAddSharp,
  IoAirplane,
  IoAirplaneOutline,
  IoAirplaneSharp,
  IoAlarm,
  IoAlarmOutline,
  IoAlarmSharp,
  IoAlbums,
  IoAlbumsOutline,
  IoAlbumsSharp,
  IoAlert,
  IoAlertCircle,
  IoAlertCircleOutline,
  IoAlertCircleSharp,
  IoAlertOutline,
  IoAlertSharp,
  IoAmericanFootball,
  IoAmericanFootballOutline,
  IoAmericanFootballSharp,
  IoAnalytics,
  IoAnalyticsOutline,
  IoAnalyticsSharp,
  IoAperture,
  IoApertureOutline,
  IoApertureSharp,
  IoApps,
  IoAppsOutline,
  IoAppsSharp,
  IoArchive,
  IoArchiveOutline,
  IoArchiveSharp,
  IoArrowBack,
  IoArrowBackCircle,
  IoArrowBackCircleOutline,
  IoArrowBackCircleSharp,
  IoArrowBackOutline,
  IoArrowBackSharp,
  IoArrowDown,
  IoArrowDownCircle,
  IoArrowDownCircleOutline,
  IoArrowDownCircleSharp,
  IoArrowDownOutline,
  IoArrowDownSharp,
  IoArrowForward,
  IoArrowForwardCircle,
  IoArrowForwardCircleOutline,
  IoArrowForwardCircleSharp,
  IoArrowForwardOutline,
  IoArrowForwardSharp,
  IoArrowRedo,
  IoArrowRedoCircle,
  IoArrowRedoCircleOutline,
  IoArrowRedoCircleSharp,
  IoArrowRedoOutline,
  IoArrowRedoSharp,
  IoArrowUndo,
  IoArrowUndoCircle,
  IoArrowUndoCircleOutline,
  IoArrowUndoCircleSharp,
  IoArrowUndoOutline,
  IoArrowUndoSharp,
  IoArrowUp,
  IoArrowUpCircle,
  IoArrowUpCircleOutline,
  IoArrowUpCircleSharp,
  IoArrowUpOutline,
  IoArrowUpSharp,
  IoAt,
  IoAtCircle,
  IoAtCircleOutline,
  IoAtCircleSharp,
  IoAtOutline,
  IoAtSharp,
  IoAttach,
  IoAttachOutline,
  IoAttachSharp,
  IoBackspace,
  IoBackspaceOutline,
  IoBackspaceSharp,
  IoBag,
  IoBagAdd,
  IoBagAddOutline,
  IoBagAddSharp,
  IoBagCheck,
  IoBagCheckOutline,
  IoBagCheckSharp,
  IoBagHandle,
  IoBagHandleOutline,
  IoBagHandleSharp,
  IoBagOutline,
  IoBagRemove,
  IoBagRemoveOutline,
  IoBagRemoveSharp,
  IoBagSharp,
  IoBalloon,
  IoBalloonOutline,
  IoBalloonSharp,
  IoBan,
  IoBanOutline,
  IoBanSharp,
  IoBandage,
  IoBandageOutline,
  IoBandageSharp,
  IoBarChart,
  IoBarChartOutline,
  IoBarChartSharp,
  IoBarbell,
  IoBarbellOutline,
  IoBarbellSharp,
  IoBarcode,
  IoBarcodeOutline,
  IoBarcodeSharp,
  IoBaseball,
  IoBaseballOutline,
  IoBaseballSharp,
  IoBasket,
  IoBasketOutline,
  IoBasketSharp,
  IoBasketball,
  IoBasketballOutline,
  IoBasketballSharp,
  IoBatteryCharging,
  IoBatteryChargingOutline,
  IoBatteryChargingSharp,
  IoBatteryDead,
  IoBatteryDeadOutline,
  IoBatteryDeadSharp,
  IoBatteryFull,
  IoBatteryFullOutline,
  IoBatteryFullSharp,
  IoBatteryHalf,
  IoBatteryHalfOutline,
  IoBatteryHalfSharp,
  IoBeaker,
  IoBeakerOutline,
  IoBeakerSharp,
  IoBed,
  IoBedOutline,
  IoBedSharp,
  IoBeer,
  IoBeerOutline,
  IoBeerSharp,
  IoBicycle,
  IoBicycleOutline,
  IoBicycleSharp,
  IoBluetooth,
  IoBluetoothOutline,
  IoBluetoothSharp,
  IoBoat,
  IoBoatOutline,
  IoBoatSharp,
  IoBody,
  IoBodyOutline,
  IoBodySharp,
  IoBonfire,
  IoBonfireOutline,
  IoBonfireSharp,
  IoBook,
  IoBookOutline,
  IoBookSharp,
  IoBookmark,
  IoBookmarkOutline,
  IoBookmarkSharp,
  IoBookmarks,
  IoBookmarksOutline,
  IoBookmarksSharp,
  IoBowlingBall,
  IoBowlingBallOutline,
  IoBowlingBallSharp,
  IoBriefcase,
  IoBriefcaseOutline,
  IoBriefcaseSharp,
  IoBrowsers,
  IoBrowsersOutline,
  IoBrowsersSharp,
  IoBrush,
  IoBrushOutline,
  IoBrushSharp,
  IoBug,
  IoBugOutline,
  IoBugSharp,
  IoBuild,
  IoBuildOutline,
  IoBuildSharp,
  IoBulb,
  IoBulbOutline,
  IoBulbSharp,
  IoBus,
  IoBusOutline,
  IoBusSharp,
  IoBusiness,
  IoBusinessOutline,
  IoBusinessSharp,
  IoCafe,
  IoCafeOutline,
  IoCafeSharp,
  IoCalculatorOutline,
  IoCalculatorSharp,
} from "react-icons/io5";

const IonicIcons = () => {
  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content container-fluid">
          {/* Page Header */}

          

          {/* /Page Header */}
          <div className="row">
            {/* Chart */}
            <div className="col-md-12">
              <div className="card">
                <div className="card-header">
                  <div className="card-title">Ionic Icon</div>
                </div>
                <div className="card-body">
                  <div className="icons-items">
                    <ul className="icons-list">
                      <li>
                        <IoAccessibilityOutline />
                      </li>
                      <li>
                        <IoAccessibilitySharp />
                      </li>
                      <li>
                        <IoAccessibility />
                      </li>
                      <li>
                        <IoAddCircleOutline />
                      </li>
                      <li>
                        <IoAddCircleSharp />
                      </li>
                      <li>
                        <IoAddCircle />
                      </li>
                      <li>
                        <IoAddOutline />
                      </li>
                      <li>
                        <IoAddSharp />
                      </li>
                      <li>
                        <IoAdd />
                      </li>
                      <li>
                        <IoAirplaneOutline />
                      </li>
                      <li>
                        <IoAirplaneSharp />
                      </li>
                      <li>
                        <IoAirplane />
                      </li>
                      <li>
                        <IoAlarmOutline />
                      </li>
                      <li>
                        <IoAlarmSharp />
                      </li>
                      <li>
                        <IoAlarm />
                      </li>
                      <li>
                        <IoAlbumsOutline />
                      </li>
                      <li>
                        <IoAlbumsSharp />
                      </li>
                      <li>
                        <IoAlbums />
                      </li>
                      <li>
                        <IoAlertCircleOutline />
                      </li>
                      <li>
                        <IoAlertCircleSharp />
                      </li>
                      <li>
                        <IoAlertCircle />
                      </li>
                      <li>
                        <IoAlertOutline />
                      </li>
                      <li>
                        <IoAlertSharp />
                      </li>
                      <li>
                        <IoAlert />
                      </li>
                      <li>
                        <IoAmericanFootballOutline />
                      </li>
                      <li>
                        <IoAmericanFootballSharp />
                      </li>
                      <li>
                        <IoAmericanFootball />
                      </li>
                      <li>
                        <IoAnalyticsOutline />
                      </li>
                      <li>
                        <IoAnalyticsSharp />
                      </li>
                      <li>
                        <IoAnalytics />
                      </li>
                      <li>
                        <IoApertureOutline />
                      </li>
                      <li>
                        <IoApertureSharp />
                      </li>
                      <li>
                        <IoAperture />
                      </li>
                      <li>
                        <IoAppsOutline />
                      </li>
                      <li>
                        <IoAppsSharp />
                      </li>
                      <li>
                        <IoApps />
                      </li>
                      <li>
                        <IoArchiveOutline />
                      </li>
                      <li>
                        <IoArchiveSharp />
                      </li>
                      <li>
                        <IoArchive />
                      </li>
                      <li>
                        <IoArrowBackCircleOutline />
                      </li>
                      <li>
                        <IoArrowBackCircleSharp />
                      </li>
                      <li>
                        <IoArrowBackCircle />
                      </li>
                      <li>
                        <IoArrowBackOutline />
                      </li>
                      <li>
                        <IoArrowBackSharp />
                      </li>
                      <li>
                        <IoArrowBack />
                      </li>
                      <li>
                        <IoArrowDownCircleOutline />
                      </li>
                      <li>
                        <IoArrowDownCircleSharp />
                      </li>
                      <li>
                        <IoArrowDownCircle />
                      </li>
                      <li>
                        <IoArrowDownOutline />
                      </li>
                      <li>
                        <IoArrowDownSharp />
                      </li>
                      <li>
                        <IoArrowDown />
                      </li>
                      <li>
                        <IoArrowForwardCircleOutline />
                      </li>
                      <li>
                        <IoArrowForwardCircleSharp />
                      </li>
                      <li>
                        <IoArrowForwardCircle />
                      </li>
                      <li>
                        <IoArrowForwardOutline />
                      </li>
                      <li>
                        <IoArrowForwardSharp />
                      </li>
                      <li>
                        <IoArrowForward />
                      </li>
                      <li>
                        <IoArrowRedoCircleOutline />
                      </li>
                      <li>
                        <IoArrowRedoCircleSharp />
                      </li>
                      <li>
                        <IoArrowRedoCircle />
                      </li>
                      <li>
                        <IoArrowRedoOutline />
                      </li>
                      <li>
                        <IoArrowRedoSharp />
                      </li>
                      <li>
                        <IoArrowRedo />
                      </li>
                      <li>
                        <IoArrowUndoCircleOutline />
                      </li>
                      <li>
                        <IoArrowUndoCircleSharp />
                      </li>
                      <li>
                        <IoArrowUndoCircle />
                      </li>
                      <li>
                        <IoArrowUndoOutline />
                      </li>
                      <li>
                        <IoArrowUndoSharp />
                      </li>
                      <li>
                        <IoArrowUndo />
                      </li>
                      <li>
                        <IoArrowUpCircleOutline />
                      </li>
                      <li>
                        <IoArrowUpCircleSharp />
                      </li>
                      <li>
                        <IoArrowUpCircle />
                      </li>
                      <li>
                        <IoArrowUpOutline />
                      </li>
                      <li>
                        <IoArrowUpSharp />
                      </li>
                      <li>
                        <IoArrowUp />
                      </li>
                      <li>
                        <IoAtCircleOutline />
                      </li>
                      <li>
                        <IoAtCircleSharp />
                      </li>
                      <li>
                        <IoAtCircle />
                      </li>
                      <li>
                        <IoAtOutline />
                      </li>
                      <li>
                        <IoAtSharp />
                      </li>
                      <li>
                        <IoAt />
                      </li>
                      <li>
                        <IoAttachOutline />
                      </li>
                      <li>
                        <IoAttachSharp />
                      </li>
                      <li>
                        <IoAttach />
                      </li>
                      <li>
                        <IoBackspaceOutline />
                      </li>
                      <li>
                        <IoBackspaceSharp />
                      </li>
                      <li>
                        <IoBackspace />
                      </li>
                      <li>
                        <IoBagAddOutline />
                      </li>
                      <li>
                        <IoBagAddSharp />
                      </li>
                      <li>
                        <IoBagAdd />
                      </li>
                      <li>
                        <IoBagCheckOutline />
                      </li>
                      <li>
                        <IoBagCheckSharp />
                      </li>
                      <li>
                        <IoBagCheck />
                      </li>
                      <li>
                        <IoBagHandleOutline />
                      </li>
                      <li>
                        <IoBagHandleSharp />
                      </li>
                      <li>
                        <IoBagHandle />
                      </li>
                      <li>
                        <IoBagOutline />
                      </li>
                      <li>
                        <IoBagRemoveOutline />
                      </li>
                      <li>
                        <IoBagRemoveSharp />
                      </li>
                      <li>
                        <IoBagRemove />
                      </li>
                      <li>
                        <IoBagSharp />
                      </li>
                      <li>
                        <IoBag />
                      </li>
                      <li>
                        <IoBalloonOutline />
                      </li>
                      <li>
                        <IoBalloonSharp />
                      </li>
                      <li>
                        <IoBalloon />
                      </li>
                      <li>
                        <IoBanOutline />
                      </li>
                      <li>
                        <IoBanSharp />
                      </li>
                      <li>
                        <IoBan />
                      </li>
                      <li>
                        <IoBandageOutline />
                      </li>
                      <li>
                        <IoBandageSharp />
                      </li>
                      <li>
                        <IoBandage />
                      </li>
                      <li>
                        <IoBarChartOutline />
                      </li>
                      <li>
                        <IoBarChartSharp />
                      </li>
                      <li>
                        <IoBarChart />
                      </li>
                      <li>
                        <IoBarbellOutline />
                      </li>
                      <li>
                        <IoBarbellSharp />
                      </li>
                      <li>
                        <IoBarbell />
                      </li>
                      <li>
                        <IoBarcodeOutline />
                      </li>
                      <li>
                        <IoBarcodeSharp />
                      </li>
                      <li>
                        <IoBarcode />
                      </li>
                      <li>
                        <IoBaseballOutline />
                      </li>
                      <li>
                        <IoBaseballSharp />
                      </li>
                      <li>
                        <IoBaseball />
                      </li>
                      <li>
                        <IoBasketOutline />
                      </li>
                      <li>
                        <IoBasketSharp />
                      </li>
                      <li>
                        <IoBasket />
                      </li>
                      <li>
                        <IoBasketballOutline />
                      </li>
                      <li>
                        <IoBasketballSharp />
                      </li>
                      <li>
                        <IoBasketball />
                      </li>
                      <li>
                        <IoBatteryChargingOutline />
                      </li>
                      <li>
                        <IoBatteryChargingSharp />
                      </li>
                      <li>
                        <IoBatteryCharging />
                      </li>
                      <li>
                        <IoBatteryDeadOutline />
                      </li>
                      <li>
                        <IoBatteryDeadSharp />
                      </li>
                      <li>
                        <IoBatteryDead />
                      </li>
                      <li>
                        <IoBatteryFullOutline />
                      </li>
                      <li>
                        <IoBatteryFullSharp />
                      </li>
                      <li>
                        <IoBatteryFull />
                      </li>
                      <li>
                        <IoBatteryHalfOutline />
                      </li>
                      <li>
                        <IoBatteryHalfSharp />
                      </li>
                      <li>
                        <IoBatteryHalf />
                      </li>
                      <li>
                        <IoBeakerOutline />
                      </li>
                      <li>
                        <IoBeakerSharp />
                      </li>
                      <li>
                        <IoBeaker />
                      </li>
                      <li>
                        <IoBedOutline />
                      </li>
                      <li>
                        <IoBedSharp />
                      </li>
                      <li>
                        <IoBed />
                      </li>
                      <li>
                        <IoBeerOutline />
                      </li>
                      <li>
                        <IoBeerSharp />
                      </li>
                      <li>
                        <IoBeer />
                      </li>
                      <li>
                        <IoBicycleOutline />
                      </li>
                      <li>
                        <IoBicycleSharp />
                      </li>
                      <li>
                        <IoBicycle />
                      </li>
                      <li>
                        <IoBluetoothOutline />
                      </li>
                      <li>
                        <IoBluetoothSharp />
                      </li>
                      <li>
                        <IoBluetooth />
                      </li>
                      <li>
                        <IoBoatOutline />
                      </li>
                      <li>
                        <IoBoatSharp />
                      </li>
                      <li>
                        <IoBoat />
                      </li>
                      <li>
                        <IoBodyOutline />
                      </li>
                      <li>
                        <IoBodySharp />
                      </li>
                      <li>
                        <IoBody />
                      </li>
                      <li>
                        <IoBonfireOutline />
                      </li>
                      <li>
                        <IoBonfireSharp />
                      </li>
                      <li>
                        <IoBonfire />
                      </li>
                      <li>
                        <IoBookOutline />
                      </li>
                      <li>
                        <IoBookSharp />
                      </li>
                      <li>
                        <IoBook />
                      </li>
                      <li>
                        <IoBookmarkOutline />
                      </li>
                      <li>
                        <IoBookmarkSharp />
                      </li>
                      <li>
                        <IoBookmark />
                      </li>
                      <li>
                        <IoBookmarksOutline />
                      </li>
                      <li>
                        <IoBookmarksSharp />
                      </li>
                      <li>
                        <IoBookmarks />
                      </li>
                      <li>
                        <IoBowlingBallOutline />
                      </li>
                      <li>
                        <IoBowlingBallSharp />
                      </li>
                      <li>
                        <IoBowlingBall />
                      </li>
                      <li>
                        <IoBriefcaseOutline />
                      </li>
                      <li>
                        <IoBriefcaseSharp />
                      </li>
                      <li>
                        <IoBriefcase />
                      </li>
                      <li>
                        <IoBrowsersOutline />
                      </li>
                      <li>
                        <IoBrowsersSharp />
                      </li>
                      <li>
                        <IoBrowsers />
                      </li>
                      <li>
                        <IoBrushOutline />
                      </li>
                      <li>
                        <IoBrushSharp />
                      </li>
                      <li>
                        <IoBrush />
                      </li>
                      <li>
                        <IoBugOutline />
                      </li>
                      <li>
                        <IoBugSharp />
                      </li>
                      <li>
                        <IoBug />
                      </li>
                      <li>
                        <IoBuildOutline />
                      </li>
                      <li>
                        <IoBuildSharp />
                      </li>
                      <li>
                        <IoBuild />
                      </li>
                      <li>
                        <IoBulbOutline />
                      </li>
                      <li>
                        <IoBulbSharp />
                      </li>
                      <li>
                        <IoBulb />
                      </li>
                      <li>
                        <IoBusOutline />
                      </li>
                      <li>
                        <IoBusSharp />
                      </li>
                      <li>
                        <IoBus />
                      </li>
                      <li>
                        <IoBusinessOutline />
                      </li>
                      <li>
                        <IoBusinessSharp />
                      </li>
                      <li>
                        <IoBusiness />
                      </li>
                      <li>
                        <IoCafeOutline />
                      </li>
                      <li>
                        <IoCafeSharp />
                      </li>
                      <li>
                        <IoCafe />
                      </li>
                      <li>
                        <IoCalculatorOutline />
                      </li>
                      <li>
                        <IoCalculatorSharp />
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            {/* /Chart */}
          </div>
        </div>
      </div>
      {/* /Page Wrapper */}
    </>
  );
};
export default IonicIcons;
